import { render, staticRenderFns } from "./BusinessDetailView.vue?vue&type=template&id=ed9d11ac&lang=pug&"
import script from "./BusinessDetailView.vue?vue&type=script&lang=js&"
export * from "./BusinessDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports